import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from "src/app/service/vpro/vpro.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-specialities',
  templateUrl: './specialities.component.html',
  styleUrls: ['./specialities.component.css']
})
export class SpecialitiesComponent implements OnInit {
  @ViewChild('SpecialityModal', { static: true } as any) SpecialityModal: TemplateRef<any>;

  specialitiesList: any = [];
  specialitiesForm: UntypedFormGroup;
  constructor(private _formBuilder: UntypedFormBuilder, private service: VproService,
    private spinner: NgxSpinnerService, private modal: NgbModal) { }

  ngOnInit() {
    this.getSpecialitiesList();
    this.specialitiesForm = this._formBuilder.group({
      name: ['', [Validators.required]]
    });

  }

  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  addSpeciality() {
    this.modal.open(this.SpecialityModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  addToDB() {
    this.modal.dismissAll();
    let data = { ... this.specialitiesForm.value }
    this.spinner.show();
    this.service
      .addSpecialities(data)
      .subscribe((result) => {
        this.spinner.hide();
        this.showToast('success', "Speciality added successfully");
        this.getSpecialitiesList();
      }, err => {
        this.spinner.hide();
        console.log(err);
        let message = "Something wrong. Couldn't complete request.";
        this.showToast('error', message);
      })
  }

  closeModal() {
    this.modal.dismissAll();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

}
